import React from "react";

import { PageProps } from "src/pages/Router/routes";
import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import Grid from "src/library/components/Hedron";
import { filterHelper } from "src/core/process-job/components/processJobTableUtils";
import ProcessJobsQueueTable from "src/core/process-job/components/ProcessJobsTable";
import { useCurrentUser } from "src/core/users/hooks";
import { Button } from "src/library/components/Button";
import { LikeToDo } from "src/library/components/LikeToDo";

const ProductReplacementJobsPages: React.ReactFCWithChildren<PageProps<unknown>> = props => {
  const { terminology } = props;
  const [ { currentRole } ] = useCurrentUser();

  const createNewButton = React.useMemo(() => {
    if (currentRole?.code !== "account-manager") {
      return (
        <Button
          onClick={() => {
            props.history.push("/admin/products/product-replacements/create");
          }}
        >
          Create New Replacement
        </Button>
      );
    } else {
      return null;
    }
  }, [ currentRole?.code, props.history ]);

  return (
    <Layout {...props}>
      <MainContentWrapper
        fill
        Header={(
          createNewButton ? (
            <LikeToDo
              copy="What would you like to do?"
              buttons={[ createNewButton ]}
            />
          ) : null
        )}
      >
        <Grid.Bounds direction="vertical">
          <ProcessJobsQueueTable
            tableName="Product Replacement Jobs"
            specificFilters={filterHelper([ "global-product-replacement" ])}
            terminology={terminology}
            excludedColumns={[ "triggeredByType", "name" ]}
            jobLinkPrefix="/admin/products/product-replacements/"
          />
        </Grid.Bounds>
      </MainContentWrapper>
    </Layout>
  );
};

export default ProductReplacementJobsPages;
